import callApi from "../../utils/callApi";
import { setDataSection, setLoading, setError } from "../reducers/policy.reducer";

export const getPolicySection = (path, sectionName) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true)); // Bắt đầu loading
      const res = await callApi(path, "GET", null);

      // Cập nhật dữ liệu section
      dispatch(setDataSection({ section: sectionName, ...res.data.data }));
      dispatch(setLoading(false)); // Kết thúc loading
    } catch (err) {
      dispatch(setError(err.message));
      dispatch(setLoading(false));
    }
  };
};
